import { Component, OnInit } from '@angular/core';
import { CompanySettingService } from '../Service/company-setting.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.css']
})
export class CancellationPolicyComponent implements OnInit {
  companyfname: string = environment.companyFullName;
  websitename: string = environment.website;

  CompanySetting = CompanySettingService;
  constructor() { }

  ngOnInit() {
  }

}
